import { useEffect, useState } from "react";

const SHARED_VIDEO_GUIDE_STORAGE_KEY = "dance-mirror-shared-video-guide-dismissed";

function hasDismissedGuide(): boolean {
  try {
    return localStorage.getItem(SHARED_VIDEO_GUIDE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function useSharedVideoGuide(enabled: boolean) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (enabled && !hasDismissedGuide()) {
      setOpen(true);
    }
  }, [enabled]);

  function dismiss() {
    try {
      localStorage.setItem(SHARED_VIDEO_GUIDE_STORAGE_KEY, "1");
    } catch {
      // Storage write failed — still close the guide for this visit.
    }
    setOpen(false);
  }

  return { open, dismiss };
}